import { toLocalDateOnly } from "@gigpro/utils/datetime";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { hireJobOffersCreate } from "../../generated/job-offers-staffer/job-offers-staffer";
import type { CreateJobOfferRequest } from "../../generated/model/createJobOfferRequest";
import { type DateOnlyInputs, toDateOnlyFields } from "../types";

type CreateVariables = { data: DateOnlyInputs<CreateJobOfferRequest, "expires_at"> };

export function useHireJobOffersCreateWithTransform(options?: {
  mutation?: Omit<
    UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersCreate>>, unknown, CreateVariables>,
    "mutationFn"
  >;
}) {
  return useMutation({
    ...options?.mutation,
    mutationFn: ({ data }: CreateVariables) =>
      hireJobOffersCreate(toDateOnlyFields(data, ["expires_at"], toLocalDateOnly)),
  });
}
